

























import { Component, Vue, Ref } from 'vue-property-decorator'
import { groupIntraAnalysis } from '@/api/teachingProtection/assessment'
import Status from './_components/Status.vue'
import Ten from './_components/Ten.vue'
import Score from './_components/Score.vue'

@Component({
  components: {
    Status,
    Score,
    Ten
  }
})
export default class extends Vue {
  private tabData = [
    { code: 101, description: '状态分布比例' },
    { code: 102, description: '10分档分布比例' },
    { code: 103, description: '得分数据' }
  ]
  private tabActive = 101
  private searchParams = {
    classroomId: '',
    name: '',
    fromTime: '',
    toTime: '',
    formModelId: ''
  }
  private info = {
    heightDistribute: { title: '身高分布', details: [] },
    bmidistribute: { title: 'BMI分布', details: [] },
    synthEZAvgScore: { title: '综合能力均分', details: [] },
    synthEZDistribute: { title: '综合能力分布', details: [] }
  }
  // 身高分布数据
  private chartHeightData = []
  // BMI分布数据
  private chartBMIData = []
  // 综合能力均分
  private chartAvgData = []
  // 综合能力分布
  private chartFBData = []

  created() {
    groupIntraAnalysis({}).then((res: any) => {
      this.$fn.setVal(this.info, res.data)
    })
  }
  private reset() {
    this.$fn.resetObject(this.searchParams)
    ;(this.$refs.table as any).search()
  }
  private search() {
    (this.$refs.table as any).update()
  }
}
